import HTTP, { USER_DOMAIN_HEADER, HEADER_REGION } from '@/utils/http'
import notification from '@/utils/notification'
import { UserDomain } from '@/utils/consts'

export const getAuthorizedRegions = async (externalId, needToken = true) => {
  try {
    const response = await HTTP.post('/auth/authorized/regions', { externalId }, { headers: { needToken } })
    return response
  } catch (err) {
    notification.handleResponseError(err, 'login')
    throw err
  }
}

export const tokenLogin = async () => {
  try {
    const res = await HTTP.get('/token-login', { headers: { needToken: true } })
    return res
  } catch (err) {
    notification.handleResponseError(err, 'login')
    throw err
  }
}

export const regionLogin = async ({ region, token }) => {
  try {
    const res = await HTTP.get('/region-login', { params: { token }, headers: { [HEADER_REGION]: region, needToken: false } })
    return res
  } catch (err) {
    notification.handleResponseError(err, 'login')
    throw err
  }
}

export const resetCookies = async () => {
  try {
    const res = await HTTP.post('resetCookies')
    return res
  } catch (err) {
    notification.handleResponseError(err)
    throw err
  }
}

export const resetExpiredPassword = async (username, domain, regionalTag) => {
  try {
    const tmsHeader = { headers: { [USER_DOMAIN_HEADER]: domain } }
    await HTTP.post('/resetexpiredpwd', { username, regionalTag }, tmsHeader)
  } catch (error) {
    notification.handleResponseError(error, 'login')
    throw error
  }
}

export const sendAuthenticationCode = async (id, contactType) => {
  let response
  try {
    response = await HTTP.post('/external/login/sendcode', { id, contactType })
  } catch (error) {
    notification.handleResponseError(error, 'authenticationCode')
    throw error
  }

  return response
}

/**
 * The first step of 2FA, obtain user contact info (email/sms)
 */
export const loginAuth = async (userPayload, domain = UserDomain.CMS) => {
  let response
  try {
    response = await HTTP.post('/external/login/auth', { ...userPayload }, { headers: { [USER_DOMAIN_HEADER]: domain } })
  } catch (error) {
    throw error
  }

  return response
}

/**
 * The second step of 2FA, check authentication code and token got from first step
 * @param {*} token
 * @param {*} code
 * @param {*} contactType
 */
export const login2FA = async (id, code) => {
  let response
  try {
    response = await HTTP.post('/external/login/2fa', { id, code })
  } catch (error) {
    throw error
  }

  return response
}

export const loginMock = async (userPayload, domain = UserDomain.CMS) => {
  let response
  try {
    response = await HTTP.post('/external/login/mock', { ...userPayload }, { headers: { [USER_DOMAIN_HEADER]: domain } })
  } catch (error) {
    throw error
  }

  return response
}

export const confirmUnlock = async (token) => {
  return HTTP.put(`/unlock/confirm/${token}`)
}
